export default function formatAmount(amount: string) {
  return parseInt(amount, 10).toLocaleString('fr-FR');
}
